import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import messages from "../../../assets/locale/messages";
import Modal from "../../../components/Modal";
import { ROUTE_PATHS } from "../../../utils/RoutesPaths";
import { AcceptBgIcon } from "../../../utils/Icons";

const AcceptCategoryRequest = ({
  open,
  closeModal,
  categoryInfo
}) => {
  const lang = useSelector((state) => state.locale.lang);

  const {
    categories: {
      categoriesRequests: { requestActions }
    },
    shared
  } = messages[lang];
  const navigate = useNavigate();
  const handleAcceptCategory = () => {
    navigate(
      ROUTE_PATHS.editCategory.replace(":id", categoryInfo.id),
      {
        state: { isRequest: true }
      }
    );
    closeModal();
  };

  const acceptCategoryRequestContent = () => {
    return (
      <div className="accept-category-request-container container d-flex flex-column justify-content-center align-items-center">
        <div className="accept-category-request mt-2 d-flex flex-column justify-content-center align-items-center text-center">
          <AcceptBgIcon />
          <Typography className="fsize-20 fweight-600 title-color mb-1">
            {requestActions.acceptConfirmTitle.replace(
              ":categoryName",
              categoryInfo?.name
            )}
          </Typography>
          <Typography className="text-color mb-1">
            {requestActions.acceptConfirmMsg}
          </Typography>
        </div>
      </div>
    );
  };

  return (
    <Modal
      modalClass={"approve-reject-category-modal"}
      open={open}
      handleConfirm={() => {
        handleAcceptCategory();
      }}
      handleClose={closeModal}
      handleCancel={closeModal}
      isContentText={false}
      content={acceptCategoryRequestContent()}
      hasActions={true}
      confirmBtnTxt={requestActions.acceptWithModification}
      cancelBtnTxt={shared.cancel}
      title
    />
  );
};

export default AcceptCategoryRequest;

AcceptCategoryRequest.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  categoryInfo: PropTypes.object.isRequired
};
